module.exports = __webpack_public_path__ + "static/media/trip-balance.9742e677.svg";